import React, { useEffect, useState } from 'react';
import * as app from "../services/AppService";
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';

interface Props extends RowItem, InterfaceComponentsProps {
    type?: string;
    model: number;
    placeholder?: string;
    elmKey?: string;
    minValue?: number;
    maxValue?: number;
    tableClass?: string;
    containerClass?: string;
    onChange?: (value: number) => void;
    onBlur?: (...args: any) => void;
}

export default function Number(Props: Props) {
    const hasIcon = Props.icon;

    const [model, setModel] = useState({
        elmntVal: "0",
        isfocused: false,
    });

    useEffect(() => {
        if (!model.isfocused) {
            setModel((old) => {
                let elmntVal = Props.model+"";
                return {
                    ...old,
                    elmntVal,
                }
            });
        }
    }, [Props.model, model.isfocused]);

    function handler(event: { target: { value: string }, preventDefault: Function }) {
        const { value } = event.target
        let elmntVal = format(value);
        if (Props.maxValue && Props.maxValue > 0 && Props.maxValue < +value) {
            event.preventDefault()
            return
        }
        if (Props.onChange && typeof Props.onChange == "function") {
            Props.onChange(+(elmntVal + "").replace(/,/g, ""));
        }
        setModel((old) => ({
            ...old,
            elmntVal,
        }));
    }

    function format(value: string | number) {
        var arr = value.toString().split(".");
        return arr && arr.length > 1 && arr[1] === ""
            ? (+arr[0] || 0)+ "."
            : (+arr[0] || 0) +
            (arr.length < 2 ? "" : "." + arr[1]);
    }

    function hanldeKeydown(evt: { keyCode: number; preventDefault: Function }) {
        if (![96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 8, 39, 37,
            46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 9, 190, 17, 86,].includes(evt.keyCode))
            evt.preventDefault();
    }

    function onBlur() {
        setModel(old => ({
            ...old,
            isfocused: false,
        }));
        if (Props.onBlur && typeof Props.onBlur == "function") Props.onBlur();
    }

    const handleFocus = (event: { target: { select: Function } }) => {
        event.target.select();
        setModel((old) => ({ ...old, isfocused: true }));
    };

    let input = (
        <input
            type="text"
            id={Props.id ? Props.id : "cur" + Props.label}
            key={Props.elmKey}
            className={`form-control border form-control-sm min-height-29  ${ 
                 Props.isTable
                ? " border-1  text-center " + Props.tableClass
                    : `border-1 ${hasIcon ? "rounded-e-1" : "rounded"} shadow-none` + Props.class}`}
            disabled={Props.disabled}
            onChange={handler}
            onKeyDown={hanldeKeydown}
            value={model.elmntVal}
            onFocus={handleFocus}
            onBlur={onBlur}
            autoComplete="off"
        />
    );

    const renderButtonIcon = () => {
        if (Props.icon) {
            const IconButton = (
                <button
                    className={`btn btn-sm border-0 p-0 px-2 bg-primary`}
                    type="button"
                 
                >
                    <i className={`iconssc-${Props.icon}`} />
                </button>
            );
            if (Props.iconTooltip) {
                return (
                    <OverlayTrigger
                        key={Props.elmKey + 'bottom'}
                        placement='bottom'
                        overlay={
                            <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                                {app.translate(Props.iconTooltip)}
                            </TooltipElm>
                        }
                    >
                        {IconButton}
                    </OverlayTrigger>
                );
            }
            return IconButton;
        }
        return null;
    };
    return Props.isTable ? <div className="focus-group">{input}</div> :
        <div className={`${!Props.label ? "margin-top-25 " : " "}`}>
            {Props.label && (
                <label className={` ms-1 ${Props.labelClass}`}>
                    {app.translate(Props.label)}
                </label>
            )}
            <div className={`input-group rounded focus-group ${Props.containerClass}`}>
                {input}
                {renderButtonIcon()}
            </div>
        </div>;
}

Number.defaultProps = {
    class: " ",
    placeholder: "",
    labelClass: " fw-semibold text-primary-emphasis ",
    containerClass: " ",
    disabled: false,
    elmKey: "num",
    isTable: false,
    minValue: 0
}


